import { Injectable } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import * as moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import * as dayjs from 'dayjs';
import { FormGroup } from '@angular/forms';
import { CONTRACT_TYPES, INDUSTRIES } from 'src/app/shared/constants';

@Injectable({
	providedIn: 'root',
})
export class UtilsService {
	constructor(private sanitizer: DomSanitizer) {}

	addZero(number: any) {
		if (typeof number === 'string') {
			number = parseInt(number);
		}
		if (number < 10) {
			return `0${number}`;
		} else {
			return number.toString();
		}
	}

	weekStartOnSunday(day: number) {
		switch (day) {
			case 7:
				return 1;
				break;

			default:
				return day + 1;
				break;
		}
	}

	defineStartWeek(date: dayjs.Dayjs) {
		let firstDayWeek = date.startOf('month').startOf('week');
		let month = firstDayWeek.month();
		let dias = 0;
		if (date.startOf('month').day() > 0) {
			while (firstDayWeek.month() === month) {
				firstDayWeek = firstDayWeek.add(1, 'day');
				dias += 1;
			}
		}
		if (dias > 3) {
			return firstDayWeek.endOf('week').add(1, 'day');
		} else {
			return firstDayWeek.startOf('week');
		}
	}

	defineEndWeek(date: dayjs.Dayjs) {
		let endDayWeek = date.endOf('month').endOf('week');
		let month = endDayWeek.month();
		let dias = 0;
		if (date.endOf('month').day() < 6) {
			while (endDayWeek.month() === month) {
				endDayWeek = endDayWeek.subtract(1, 'day');
				dias += 1;
			}
		}
		if (dias > 3) {
			return endDayWeek.startOf('week').subtract(1, 'day');
		} else {
			return endDayWeek.endOf('week');
		}
	}

	ngbDateToPHP(date: NgbDate) {
		let month = this.addZero(date.month);
		let day = this.addZero(date.day);

		return `${date.year}-${month}-${day} `;
	}

	ngbTimeToPHP(time: any) {
		time.hour = this.addZero(time.hour);
		time.minute = this.addZero(time.minute);
		if (time.second) {
			time.second = this.addZero(time.second);
			return `${time.hour}:${time.minute}:${time.second}`;
		}

		return `${time.hour}:${time.minute}:00`;
	}

	nowPHP() {
		let date = moment().format('YYYY-MM-DD HH:mm:ss');
		return date;
	}

	phptoNgbDate(date: string) {
		let arrDate = date.split(' ');
		arrDate = date.split('-');

		return new NgbDate(parseInt(arrDate[0]), parseInt(arrDate[1]), parseInt(arrDate[2]));
	}

	exportExcel(id: any) {
		let element = document.getElementById(id);
		const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
		XLSX.writeFile(wb, id + '.xlsx');
	}

	//Input Format 23:10 PM
	time12To24(time: string) {
		var hour = '';
		var min = '';

		if (time.includes('PM')) {
			hour = time.split(':')[0];
			min = time.split(':')[1].split(' ')[0];

			var horaInt = parseInt(hour) + 12;
			hour = horaInt.toString();

			return hour + ':' + min + ':00';
		} else {
			return time.split(' ')[0] + ':00';
		}
	}

	Time24To12(time: String) {
		let timeArray = time.split(':');
		let time12 = '';
		let ampm = '';
		if (parseInt(timeArray[0]) > 12) {
			var hour = parseInt(timeArray[0]) - 12;

			time12 += this.addZero(hour);
			ampm = 'PM';
		} else {
			time12 += this.addZero(timeArray[0]);
			ampm = 'AM';
		}

		time12 += ':' + this.addZero(timeArray[1]) + ' ' + ampm;

		return time12;
	}

	jsDateToPHP(date: Date) {
		return `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;
	}

	ngbDateToJS(date: NgbDate) {
		let month = this.addZero(date.month);
		let day = this.addZero(date.day);

		return Date.parse(`${date.year}-${month}-${day}`);
	}

	ngbDateToUnix(date: NgbDate, time = 'start') {
		if (time == 'start') {
			return new Date(date.year, date.month - 1, date.day, 0, 0, 0).getTime() / 1000;
		} else {
			return new Date(date.year, date.month - 1, date.day, 23, 59, 59).getTime() / 1000;
		}
	}

	getTypesIcons(strTypes: string) {
		const types: string[] = strTypes.split(',');
		let iconTypes = '';
		types.map((type) => {
			if (parseInt(type) == 1) {
				iconTypes += '<i class="ri-service-fill" style="font-size:18px"></i>';
			}
			if (parseInt(type) == 2) {
				iconTypes += '<i class="ri-phone-fill" style="font-size:18px"></i>';
			}
			if (parseInt(type) == 3) {
				iconTypes += '<i class="ri-macbook-fill" style="font-size:18px"></i>';
			}
		});
		return this.sanitizer.bypassSecurityTrustHtml(iconTypes);
	}

	getTypesIconLead(strTypes: string) {
		switch (strTypes) {
			case '1':
				return '<i class="ri-shake-hands-line" aria-hidden="true"></i>';
				break;
			case '2':
				return '<i class="ri-phone-fill" aria-hidden="true"></i>';
				break;

			case '3':
				return '<i class="ri-macbook-fill" aria-hidden="true"></i>';
				break;

			default:
				return null;
				break;
		}
	}

	swal(title: any, type: any, text = '') {
		return Swal.fire({
			title: title,
			text: text,
			showCancelButton: false,
			confirmButtonText: 'Ok',
		});
	}

	getUserPass(last: any) {
		let str;
		let pass;

		if (last.length > 4) {
			str = last.substring(0, 4);
		} else if (last.length <= 4) {
			str = last;
		}

		pass = str.replace(/./g, (x: any) => '22233344455566677778889999'[(x.charCodeAt() - 65) % 32] || x);

		if (pass.length === 4) {
			return pass;
		} else if (pass.length === 3) {
			return '0' + pass;
		} else if (pass.length === 2) {
			return '00' + pass;
		} else if (pass.length === 1) {
			return '000' + pass;
		}
	}

	exportWord(contentHtml: any, nameDocument: any) {
		var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(contentHtml);
		var fileDownload = document.createElement('a');
		document.body.appendChild(fileDownload);
		fileDownload.href = source;
		fileDownload.download = nameDocument + '.doc';
		fileDownload.click();
		document.body.removeChild(fileDownload);
	}

	jsonToFormData(json) {
		const formData = new FormData();
		for (let key in json) {
			if (json.hasOwnProperty(key)) {
				formData.append(key, json[key]);
			}
		}
		return formData;
	}

	formatMiliSeconds(ms) {
		// Convertir milisegundos a segundos
		const seconds = ms / 1000;

		// Determinar el formato a aplicar
		if (seconds < 60) {
			// Menos de 1 minuto
			return `${Math.floor(seconds)}s`;
		} else if (seconds < 3600) {
			// Menos de 1 hora, convertir a minutos
			return `${Math.floor(seconds / 60)}m`;
		} else {
			// Horas
			return `${Math.floor(seconds / 3600)}h`;
		}
	}

	// TODO: choose one of this two fucntions is better
	formatSeconds(seconds) {
		// Determinar el formato a aplicar
		if (seconds < 60) {
			// Menos de 1 minuto
			return `${Math.floor(seconds)}s`;
		} else if (seconds < 3600) {
			// Menos de 1 hora, convertir a minutos
			return `${Math.floor(seconds / 60)}m`;
		} else {
			// Horas
			return `${Math.floor(seconds / 3600)}h`;
		}
	}

	formatSeconds2(seconds: any) {
		const hours = Math.floor(seconds / 3600);
		const minutes = Math.floor((seconds % 3600) / 60);

		let result = '';

		if (hours > 0) {
			result += `${hours} hr`;
			if (minutes > 0) {
				result += ` ${minutes} min`;
			}
		} else {
			result += `${minutes} min`;
		}
		return result;
	}

	validateInput(controlName: string, form: FormGroup) {
		const control = form.get(controlName);
		return {
			'is-valid': control.valid && control.touched,
			'is-invalid': control.invalid && control.touched,
		};
	}

	inputSanitizeNumber(event: any): string {
		const input = event.target.value;
		const sanitizedInput = input.replace(/[^0-9]/g, ''); // Remove non-numeric characters
		event.target.value = sanitizedInput; // Update the input value
		return sanitizedInput;
	}

	// CONSTANTS GET VALUES

	/**
	 * Get campaign type label
	 */
	getContractTypeLabel(value: string): string {
		const type = CONTRACT_TYPES.find((t) => t.name === value);
		return type ? type.name : value;
	}

	getIndustryLabel(value): string {
		const industry = INDUSTRIES.find((i) => i.id == value);
		return industry ? industry.description : value;
	}

	public getApptTypesIcons(strTypes: string) {
		const types: string[] = strTypes.split(',');
		let iconTypes = '';
		types.map((type) => {
			if (parseInt(type) === 1) {
				iconTypes += '<i class="ri-service-fill"></i>';
			}
			if (parseInt(type) === 2) {
				iconTypes += '<i class="ri-phone-fill"></i>';
			}
			if (parseInt(type) === 3) {
				iconTypes += '<i class="ri-macbook-fill"></i>';
			}
		});
		return this.sanitizer.bypassSecurityTrustHtml(iconTypes);
	}


}
